export default __webpack_public_path__ + "static/media/Saravana.dc1abcd6.png";